<template>
	<a :href="fundData.url" class="fund-card-header">
		<h3 class="fund-card-title">
			<span class="fg--red">{{ fundData.symbol }}</span>
			{{ name }}
		</h3>
		<p
			v-if="fundData.description"
			class="p2 fund-card-description"
			v-html="fundData.description"
		/>
	</a>
</template>

<script>
export default {
	name: "FundCardHeader",

	props: {
		fundData: {
			type: Object
		},

		name: {
			type: String
		}
	}
};
</script>

<style lang="scss">
.fund-card {
	&-header {
		min-height: 225px;
		padding: 44px 32px;

		@include from-md() {
			padding: 32px 18px;
		}
	}

	&-title {
		font-size: 40px;
		font-weight: $font-weight--normal;
		line-height: 1;
		margin-bottom: 0;
		color: $color--almost-black;

		.fg--red {
			display: block;
		}
	}
}
</style>
